export const TYPE_ADDRESS_IMAGE = 'image'
export const TYPE_ADDRESS_GOOGLE_MAP = 'google-map'
